module.exports = __webpack_public_path__ + "img/bg13.8ab8d08b.png";